import cx from 'classnames';
import React, { forwardRef } from 'react';
import styles from './Icons.module.css';

type OwnProps = React.SVGProps<SVGSVGElement>;

const BangCircleIcon = forwardRef<SVGSVGElement, OwnProps>(
  ({ className, ...props }, ref) => (
    <svg
      viewBox="0 0 20 20"
      ref={ref}
      className={cx(className, styles['bang-circle'])}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM10 4C10.5523 4 11 4.44772 11 5V11C11 11.5523 10.5523 12 10 12C9.44772 12 9 11.5523 9 11V5C9 4.44772 9.44771 4 10 4ZM10 16C10.5523 16 11 15.5523 11 15C11 14.4477 10.5523 14 10 14C9.44771 14 9 14.4477 9 15C9 15.5523 9.44771 16 10 16Z"
        fill="#EB9F23"
      />
    </svg>
  )
);

export default BangCircleIcon;
